// Transaction Types based on API documentation
export enum PointsTransactionType {
  ORDER = "ORDER",
  ADMIN_ADJUST = "ADMIN_ADJUST",
  REFERRAL = "REFERRAL",
  REDEMPTION_DISCOUNT = "REDEMPTION_DISCOUNT",
  REDEMPTION_HYBRID = "REDEMPTION_HYBRID",
  REDEMPTION_POINTS_ONLY = "REDEMPTION_POINTS_ONLY",
}

// Transaction object matching the API response
export interface CapsulePointTransaction {
  id: number;
  orderId: number | null;
  userId: number;
  orderDate: string;
  totalAmount: number;
  finalAmount: number;
  earnPoints: number;
  usedPoints: number;
  pointsBefore: number;
  pointsAfter: number;
  type: PointsTransactionType | null;
  reason: string | null;
}

// API Response structure
export interface PointsTransactionListResponse {
  transactions: CapsulePointTransaction[];
  meta: {
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
    totalPages: number;
  };
}

// Request filters
export interface PointsTransactionFilters {
  page?: number;
  limit?: number;
}
